import { render, staticRenderFns } from "./TinTucMoiNhat.vue?vue&type=template&id=08f946aa&scoped=true&"
import script from "./TinTucMoiNhat.vue?vue&type=script&lang=js&"
export * from "./TinTucMoiNhat.vue?vue&type=script&lang=js&"
import style0 from "./TinTucMoiNhat.vue?vue&type=style&index=0&id=08f946aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f946aa",
  null
  
)

export default component.exports